<template>
  <div class="dataApi">
    <navs></navs>
    <div class="top">
<!--      <p class="bigTitle">数据API</p>-->
<!--      <p class="smallTitle">The DATA API</p>-->
    </div>

    <!--数据采集-->
    <div class="servers">
      <div class="titles"> 多渠道数据集成</br>全面覆盖国内船舶、货车数据</div>
      <p class="collectSub">
        信号覆盖更广、接收频率更高、响应速度更快</br>数据源涵盖：岸基、移动基站、卫星GPS、AIS设备、移动设备
      </p>
      <div class="map"></div>
    </div>
    <!--运费竟价-->
    <div class="price">
      <div class="titles">API接口</div>
      <van-swipe class="my-swipe1" :autoplay="3000">
        <van-swipe-item style="margin-bottom: 25px">
          <div class="swipe" style="display: flex;justify-content: space-between">
            <img src="../assets/dingwei.jpg" style="margin-left: 5px"/>
            <img src="../assets/guiji.jpg" style="margin-right: 5px"/>
          </div>
        </van-swipe-item>
        <van-swipe-item style="margin-bottom: 25px">
          <div class="swipe" style="display: flex;justify-content: space-between">
            <img src="../assets/dangan.jpg" style="margin-left: 5px"/>
            <img src="../assets/dongtai.jpg" style="margin-right: 5px"/>
          </div>
        </van-swipe-item>
        <van-swipe-item style="margin-bottom: 25px">
          <div class="swipe" style="display: flex;justify-content: space-between">
            <img src="../assets/chaoxi.jpg" style="margin-left: 5px"/>
            <img src="../assets/qixiang.jpg" style="margin-right: 5px"/>
          </div>
        </van-swipe-item>
      </van-swipe>
    </div>
    <div class="servers">
      <div class="titles">船舶可视化</div>
      <p class="collectSub">
        标准数据接口，实现可视化跟踪与管理</br>支持定制服务，助力数字化转型与升级
      </p>
      <video class="video" src="static/video.mov" controls></video>
    </div>
    <div class="price">
      <div class="top-title">客户案例</div>
      <div class="titles">01 / 海运平台</div>
      <p class="collectSub">
        满足客户税务方面合规性审查要求，对平台的运输交易业务进行溯源，查询历史运输轨迹，佐证业务真实性。
      </p>
      <div class="haiyun"></div>
    </div>
    <div class="servers">
      <div class="titles">02 / 船务公司</div>
      <p class="collectSub">
        实现公司自有船舶的管理需求，实时掌握最新船舶动态，提供航程航速分析，为船舶提供气象灾害预警及动态提醒。
      </p>
      <div class="chuanwu"></div>
    </div>
    <foot></foot>
    <rightC></rightC>
  </div>
</template>
<script>
import navs from '@/components/nav/head';
import foot from '@/components/nav/footer';
import rightC from '@/components/nav/rightFloat'

export default {
  name: 'dataApi',
  data() {
    return {
      current: 0,
      src: null,
    }
  },
  components: {
    navs, foot, rightC
  },
  created() {
  }
}
</script>
<style lang='less' rel='stylesheet/less'>
@rem: 16rem;
@col-f: #fff;
.top {
  width: 100%;
  height: 160/@rem;
  background: url('../assets/banner.jpg');
  background-repeat: no-repeat;
  background-position: center center;
  background-size: ceil(100%) ceil(100%);
  align-items: center;

  p {
    text-align: center;
    color: @col-f;
    font-size: 22/@rem;
    padding-top: 50/@rem;
    margin: 0;
    font-weight: 400;
    margin-left: 140/@rem;
  }

  .smallTitle {
    text-align: center;
    color: @col-f;
    font-size: 15/@rem;
    padding-top: 1/@rem;
    font-weight: 300;

  }
}

.starsBox {
  width: 100%;
  height: 428/@rem;
  background: #020E39;
  text-align: center;

  .starTitle {
    padding-top: 30/@rem;
    font-size: 18/@rem;
    text-align: center;
    color: @col-f;
    font-weight: 300;
  }

  .beiIntro {
    font-size: 10/@rem;
    color: @col-f;
    padding-left: 19/@rem;
    padding-right: 19/@rem;
    font-weight: 300;
    text-align: left;
    line-height: 20/@rem
  }

  .starsImg {
    width: 100%;
    height: 228/@rem;
    background: url('../assets/bei-b.png');
    background-repeat: no-repeat;
    background-position: center bottom;
    background-size: 290/@rem 210/@rem;
  }
}


.servers {
  padding: 22/@rem 16/@rem;

  .titles {
    font-size: 16/@rem;
    text-align: center;
    color: #333;
    font-weight: 500;
  }

  .collectSub {
    font-size: 10/@rem;
    color: #666;
    //   text-align: justify;
    //   text-align-last: center;
    text-align: center;
    line-height: 16/@rem;

  }

  .map {
    width: 100%;
    height: 148/@rem;
    background: url('../assets/qudao.png');
    background-repeat: no-repeat;
    background-position: center center;
    background-size: 260/@rem 128/@rem;
  }

  .chuanwu {
    width: 100%;
    height: 168/@rem;
    background: url('../assets/chuangwu.jpg');
    background-repeat: no-repeat;
    background-position: center center;
    background-size: 260/@rem 148/@rem;
  }
}

.price {
  padding: 22/@rem 16/@rem;
  background: rgba(248, 249, 250, 1);

  .titles {
    font-size: 16/@rem;
    text-align: center;
    color: #333;
    font-weight: 500;
  }

  .top-title {
    font-size: 18/@rem;
    text-align: center;
    color: #333;
    font-weight: 500;
    margin-bottom: 40/@rem;
  }

  .collectSub {
    font-size: 10/@rem;
    color: #666;
    //    text-align: justify;
    //   text-align-last: center;
    text-align: center;
    line-height: 16/@rem;

  }

  .collectImg {
    width: 100%;
    height: 168/@rem;
    background: url('../assets/zhi-2.png');
    background-repeat: no-repeat;
    background-position: center center;
    background-size: 270/@rem 138/@rem;
  }

  .my-swipe1 {
    margin-top: 30/@rem;
  }

  .haiyun {
    width: 100%;
    height: 168/@rem;
    background: url('../assets/haiyun.jpg');
    background-repeat: no-repeat;
    background-position: center center;
    background-size: 260/@rem 148/@rem;
  }
}

.footer {
  margin-top: 0
}

.swipe img {
  width: 135/@rem;
  height: 300/@rem;
  background: #FFFFFF;
  box-shadow: 0/@rem 0/@rem 5/@rem 0/@rem rgba(6, 6, 6, 0.15);
  border-radius: 10/@rem;
}

.video {
  width: 100%;
  height: 200/@rem;
}
</style>



// WEBPACK FOOTER //
// src/components/dataApi.vue